import React from 'react';
import LegacyProfilePage from './ProfilePage.legacy';
function ProfilePage({ mountains }) {
  return <LegacyProfilePage mountains={mountains} />;
}

export default ProfilePage;
